export enum HeapCustomEvent {
  BreakdownCreated = "Breakdown Created",
  TapeRequestSent = "Tape Request Sent",
  AgentRequestReceived = "Agent - Tape Request Received",
  CDToPerformerRequestReceived = "CD 2 Performer - Tape Request Received",
  AgentToPerformerRequestReceived = "Agent 2 Performer - Tape Request Received",
  AgentSendTapeRequestToPerformer = "Agent - Send Tape Request To Performer",
  AgentTapeRequestUpload = "Agent - Tape Request upload",
  PerformerTapeRequestUpload = "Performer - Tape Request upload",
  TapeRequestForbidden = "Tape Request Forbidden",
  // close breakdown early
  ClickClose = "CD - Step 1 : Click close breakdown early",
  ExitClose = "CD - Step 2: Exit close breakdown early",
  ReasonAndConfirm = "CD - Step 2: Reason and  confirm closing breakdown early",
  CosedEarly = "CD - Step 3: Breakdown is closed early",
  ExitConfirm = "CD - Step 3: Exit closing breakdown early",
  BackToStepTwo = "CD - Step 3: Back to step 2",
  // agent self tape request settings
  AgentSelfTapeEditSettings = "agent - editing self-tape settings",
  AgentSelfTapeToggleSetting = "agent - toggle self-tape setting",
  AgentSelfTapeSaveAndClose = "agent - save and close self-tape",
  AgentSelfTapeCancelSettings = "agent - cancel self-tape settings",
  // performer subscription plan
  PerformerCancelSubscription = "cancel_subscription",
  PerformerChangePlan = "Change Subscription Selected",
  PerformerAnotherPlan = "Change Subscription Type",
  PerformerChangePlanCancelled = "Change Subscription Cancelled",
  PerformerCancelSubscriptionModal = " Subscription Type",
  // social media events
  CdClickedSocialLink = "cd_clicked_social_link",
}
